module.exports = __webpack_public_path__ + "img/virginia.a5adc4c4.gif";